<template>
  <div
    @click="closeSelf"
    style="
      width: 100vw;
      height: 100vh;
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #999;
      z-index: 1;
      opacity: 0.9;
    "
  >
    <div
      @click.stop=""
      style="width: 90%; background: white; border: 1px solid #333; opacity: 1;"
    >
      <div class="smiles-canvas-wrapper" style="background: white;">
        <div class="fan-con">
          <div v-for="item in allSmiles[0].arr">
            <canvas
              v-if="item.class === 'canvas'"
              :id="item.id"
              :class="item.class"
            >
            </canvas>
            <div :id="item.id" :class="item.class" v-else>
              +
            </div>
          </div>
        </div>
        <div class="cui-con">
          <div
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              padding-bottom: 20px;
            "
          >
            <div v-for="item in allSmiles[1].arr">
              <canvas
                v-if="item.class === 'canvas'"
                :id="item.id"
                :class="item.class"
              >
              </canvas>
            </div>
          </div>
        </div>
        <div class="sheng-con">
          <div v-for="item in allSmiles[2].arr">
            <canvas
              v-if="item.class === 'canvas'"
              :id="item.id"
              :class="item.class"
            >
            </canvas>
            <div :id="item.id" :class="item.class" v-else>
              +
            </div>
          </div>
        </div>
      </div>

      <div
        class="mole-canvas-wrapper"
        style="
          background: white;
          border-top: 1px solid #999999;
          border-bottom: 1px solid #999999;
        "
      >
        <div
          :class="[item.class, 'mole-fan']"
          v-for="item in allSmiles[0].arr"
          style="padding: 0 10px;"
        >
          <div v-if="item.class === 'canvas'">{{ item.mole }}</div>
          <div v-else>+</div>
        </div>
        <div class="mole-cui">
          <div style="padding: 0 5px;" v-for="item in allSmiles[1].arr">
            {{ item.mole }}
          </div>
        </div>
        <div class="mole-sheng" v-for="item in allSmiles[2].arr" style="">
          <div v-if="item.class === 'canvas'">{{ item.mole }}</div>
          <div v-else>+</div>
        </div>
      </div>

      <div class="description" style="">
        <div class="cui-itmes-wrapper" style="">
          <span>催化剂:</span>
          <span
            class="cui-items"
            style="padding: 2px 5px 0;"
            v-for="item in allSmiles[1].arr"
          >
            {{ item.mole }}</span
          >
        </div>
        <span v-if="yield1"> 产率: {{ yield1 }} </span>
      </div>
    </div>
  </div>
</template>

<script>
import SmilesDrawer from "smiles-drawer";

export default {
  name: "CanvasReaction",
  props: {
    str: String,
    allSmiles: Array,
    yield1: String,
  },
  data() {
    return {
      showAll: false,
    };
  },

  mounted() {
    this.drawSmiles(this.allSmiles);
  },
  methods: {
    closeSelf() {
      this.$emit("closeSelf");
    },
    drawSmiles(smiles) {
      let options = {
        width: 100,
        height: 100,
        debug: false,
        atomVisualization: "default",
        explicitHydrogens: true,
      };

      let smilesDrawer = new SmilesDrawer.Drawer(options);
      for (let i = 0; i < smiles.length; i++) {
        for (let j = 0; j < smiles[i].arr.length; j++) {
          if (smiles[i].arr[j].class === "canvas") {
            SmilesDrawer.parse(
              smiles[i].arr[j].smile,
              (tree) => {
                smilesDrawer.draw(tree, smiles[i].arr[j].id, "light", false);
                let aaa = smilesDrawer.getMolecularFormula();
                smiles[i].arr[j].mole = aaa;
              },
              function (err) {
                console.log(err);
                console.log(err);
              }
            );
          }
        }
      }
    },
    changeAllSmiles(arr, index) {
      let newArr = [];
      for (let i = 0; i < arr.length; i++) {
        newArr.push({
          class: "canvas",
          id: this.genID(),
          smile: arr[i],
          mole: "",
        });
        if (i !== arr.length - 1 && index !== 2) {
          newArr.push({ class: "connect", smile: "" });
        }
      }

      this.allSmiles.push({
        arr: newArr,
      });
    },
    genID(length) {
      return Number(
        Math.random().toString().substr(3, length) + Date.now()
      ).toString(36);
    },
  },
};
</script>

<style lang="scss">
.smiles-canvas-wrapper {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .fan-con {
    margin-right: 20px;
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .cui-con {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .sheng-con {
    margin-left: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.mole-canvas-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .mole-cui {
    padding: 10px 20px;
    margin-bottom: 30px;
    position: relative;
    display: flex;
  }

  .mole-sheng {
    padding: 0 10px;
  }
}

.description {
  text-align: left;
  padding: 10px;
  display: flex;
  align-items: center;

  .cui-itmes-wrapper {
    display: flex;
    justify-content: left;
    align-items: center;
    width: 50%;
  }
}

.cui-con::after {
  content: "";
  display: block;
  position: absolute;
  top: 70%;
  left: 0;
  width: 100%;
  height: 2px;
  background: #333;
}

.cui-con::before {
  content: "";
  display: block;
  position: absolute;
  top: calc(70% - 5px);
  left: 100%;
  width: 0;
  height: 0;
  border-top: 6px solid white;
  border-bottom: 6px solid white;
  border-right: 18px solid white;
  border-left: 18px solid #333;
  background: #333;
}

.mole-cui::after {
  content: "";
  display: block;
  position: absolute;
  top: 33px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #333;
}

.mole-cui::before {
  content: "";
  display: block;
  position: absolute;
  top: 28px;
  left: calc(100% - 15px);
  width: 0;
  height: 0;
  border-top: 6px solid white;
  border-bottom: 6px solid white;
  border-right: 0 solid white;
  border-left: 18px solid #333;
  background: #333;
}
</style>
